import { makeStyles } from "@material-ui/core"
import React from "react"
import { sparklesSvg } from "./Svg"

const useStyles = makeStyles(() => ({
    container: {
        position: "relative",
        margin: "auto",
        width: "min(86%, 980px)",
        height: "86%",
        borderRadius: 36,
        border: "1px solid rgba(255,255,255,.35)",
        background: "rgba(255,255,255,.08)",
        boxShadow: "0 20px 60px rgba(0,0,0,.35), inset 0 1px 0 rgba(255,255,255,.2)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        padding: "48px 28px",
        zIndex: 2,
    },
    brilho: {
        position: "absolute",
        inset: 0,
        backgroundImage: `url("data:image/svg+xml;utf8,${sparklesSvg}")`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        opacity: 0.7,
        pointerEvents: "none",
        borderRadius: 36,
    },
}))

type Props = {
    children: React.ReactChild
}

export function CointainerDados({ children }: Props) {
    const classes = useStyles()

    return (
        <div className={classes.container}>
            <div className={classes.brilho} />
            {children}
        </div>
    )
}
